module.exports = __webpack_public_path__ + "static/media/icon_logout.487dcb0d.svg";